import { promiseFetch } from '@accedo/promise-fetch';
import { getInternalErrorMessage } from '##/components/Error/error';
import { config } from '##/services/store/store';
import { RequestRejectionError } from '../types';
import { constructApiUrl, sendApiRequest } from '../apirequest';
import { RegionResponse, AppConfigResponse } from './types';

const { regionServiceUrl, systemName } = config.$get().api;

export const getUserRegion = (): Promise<RegionResponse> =>
  promiseFetch(`${regionServiceUrl}?app=uaplite`, {
    method: 'GET',
    responseType: 'json',
  })
    .then((response) => response.data)
    .catch((error) => {
      const internalErrorType = getInternalErrorMessage(error).type;
      const reason: RequestRejectionError = { internalErrorType, error };

      return Promise.reject(reason);
    });

export const getAppConfig = (
  manufacturer = 'Unknown',
): Promise<AppConfigResponse> => {
  const url = constructApiUrl(
    'config',
    {},
    {
      SystemName: systemName,
      manufacturer,
    },
  );
  return sendApiRequest<AppConfigResponse>(url);
};
